import webSocket from './webSocket'
import { sendLogin, sendReady, sendChat, sendRead, getHistory, sendOnTyping } from './action'
import emitter from './emitter'
import { loading, getQueryObject, tip, getCache } from './utils'
import TYPE from './emitType'
import dayjs from 'dayjs'
import { pick } from 'lodash-es'
import 'intersection-observer'

import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

export default {
  install: app => {
    app.use(['layer-mobile', 'layim-mobile'], (layer, layim) => {
      const { send, socket } = webSocket.install(app)
      // 账号在别处登录(err=3)后不再重连/重试登录
      let stopLoginRetry = false

      // socket 连接成功
      emitter.on(TYPE.SOCKET_OPEN, e => {
        if (stopLoginRetry) return
        loading.open('Logging in ...')
        // 请求登录
        send(sendLogin())
      })

      // socket 重新连接
      emitter.on(TYPE.SOCKET_RECONNECT, e => {
        loading.open('Reconnecting ...')
      })

      // socket 连接失败
      emitter.on(TYPE.SOCKET_ERROR, () => {
        // layer.open({
        //   title: 'tip',
        //   content: `socket is error`,
        //   btn: 'Login again',
        //   yes(i) {
        //     location.reload()
        //   }
        // })
      })

      // socket 关闭
      emitter.on(TYPE.SOCKET_CLOSE, () => {
        // layer.open({
        //   title: 'tip',
        //   content: `socket is close`,
        //   btn: 'Login again',
        //   yes(i) {
        //     location.reload()
        //   }
        // })
      })

      // 登录成功
      emitter.on(TYPE.LOGIN_SUCCESS, () => {
        // 发送准备完毕得到 分配的客服 和 历史记录
        send(sendReady())
        // test()
      })

      // 登录失败
      emitter.on(TYPE.LOGIN_FAIL, ({ msg, code }) => {
        if (code === 3) {
          // Your account is logged in another place — 停止 Sockette 自动重连与登录重试
          stopLoginRetry = true
          socket?.close()
        } else {
          // 其它失败仍关闭底层 ws，允许 Sockette 按策略重连
          socket?.ws?.close()
        }
        loading.close()
        layer.open({
          content: msg,
          time: 2
        })
        // layer.open({
        //   title: 'tip',
        //   content: `${msg}`,
        //   btn: 'Login again',
        //   yes(i) {
        //     location.reload()
        //   }
        // })
      })

      // 准备基础信息成功
      emitter.on(TYPE.READY_SUCCESS, () => {
      })

      // 准备基础信息失败
      emitter.on(TYPE.READY_FAIL, ({ msg, code }) => {
        tip(`${msg}: ${code}`)
      })

      // 得到分配的客服
      emitter.on(TYPE.GET_CUSTOMER_SERVICE_SUCCESS, ({ id, userInfo }) => {
        loading.close()
        console.log('客服信息 => ', userInfo)
        getCache().customerService = userInfo
        // 登录或者重连
        initIm()
        createChat()
        send(getHistory(id))
      })

      // 得到分配的客服失败
      emitter.on(TYPE.GET_CUSTOMER_SERVICE_FAIL, ({ msg, code }) => {
        tip(`${msg}: ${code}`)
      })

      // 获取历史消息
      emitter.on(TYPE.GET_HISTORY_SUCCESS, ({ list, userInfo }) => {
        const thatChat = layim.thisChat()
        const dom = thatChat.elem[0]
        const ul = dom.querySelector('.layim-chat-main ul')
        const { mine: mineInfo } = getCache()
        if (!dom.dataset.loadHistory) {
          if (list.length) {
            const historyHtml = list.map(item => {
              return `
            <li id="${item.messageId}" data-read="${item.state}" data-mine="${Number(item.mine)}" ${item.mine ? 'class="layim-chat-mine"' : ''}>
                <div class="layim-chat-user">
                    <div class="layim-chat-avatar">
                        <img src="${(item.mine ? mineInfo.avatar : userInfo.avatar)}" />
                    </div>
                    <cite>
                        ${!item.mine ? userInfo.nick : ''}
                        <i>${dayjs(item.timestamp).format('DD/MM HH:mm')}</i>
                        ${item.mine ? mineInfo.nick : ''}
                    </cite>
                </div>
                <div class="layim-chat-text ${/.*img\[.+\].*/.test(item.content) ? 'layim-chat-img' : ''}">${layim.content(item.content)}</div>
            </li>
          `
            }).join('')
            ul.insertAdjacentHTML('afterbegin', historyHtml)
            resetScroll(userInfo)
            list.forEach(item => readMessage.observe(item.messageId))
          }
          // 标记为已加载历史消息
          dom.dataset.loadHistory = '1'
        }
      })

      // 自己或者对方发送的消息
      emitter.on(TYPE.CHAT, res => {
        layim.getMessage(Object.assign(res, pick(getUserById(res.sendId), ['avatar', 'username', 'nick'])))
        resetScroll()
        readMessage.observe(res.messageId)
      })

      // 发送失败
      emitter.on(TYPE.SEND_FAIL, ({ msg, code }) => {
        tip(`${msg}: ${code}`)
      })

      // 已读消息成功
      emitter.on(TYPE.READ_MESSAGE_SUCCESS, ({ messageId }) => {
        const target = document.getElementById(messageId)
        // 我的消息设置为已读
        if (target && target.dataset.mine === '1') {
          target.dataset.read = '1'
        }
      })

      // 已读消息失败
      emitter.on(TYPE.READ_MESSAGE_FAIL, ({ msg }) => {
        //console.warn(`read message fail: ${msg}`)
      })

      // 撤回消息成功
      emitter.on(TYPE.RECALL_MESSAGE_SUCCESS, ({ messageId }) => {
        const dom = document.getElementById(messageId)
        if (dom) {
          readMessage.unobserve(messageId)
          dom.remove()
        }
      })

      // 正在输入成功
      emitter.on(TYPE.TYPING_SUCCESS, ({ userId }) => {
        //layer.msg(`${userId} ontyping success`, { icon: 1, time: 1500 })
        layim.setChatStatusBrief('<span style="color:#ffffff;">正在输入...</span>'); //模拟标注好友在线状态
        var tid = layim.cache().typing_tid ?? 0;
        if(tid != 0) clearTimeout(tid);
        var new_tid = setTimeout(function(){
          layim.setChatStatusBrief('');
        }, 1000);
        layim.cache().typing_tid = new_tid;
      })

      // 监听发送的消息
      layim.on('sendMessage', res => {
        send(sendChat(res))
      })

      // 监听点击图片
      layim.on('photos', event => {
        const target = event[0]
        const pswpElement = document.getElementById('pswp')
        const photosElement = [...document.querySelectorAll('.layui-layim-photos')]
        const items = photosElement.map(item => {
          const { src, dataset: { size }} = item
          const [w, h] = size.split('x')
          return {
            src,
            w,
            h
          }
        })
        const options = {
          index: photosElement.indexOf(target),
          history: false
        }
        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
        gallery.init()
      })

      //
      layim.on('onTyping', data => {
        send(sendOnTyping(data))
      })

      function getUserById(id) {
        const { mine, customerService } = getCache()
        if (mine.id === id) {
          return mine
        }
        return customerService
      }

      function initIm() {
        layim.config({
          chatTitleColor: '#cc9254',
          title: 'Customer Service',
          // 简约模式
          brief: true,
          // 设定消息提醒的声音
          voice: false,
          // 开启桌面消息提醒
          notice: true,
          // 可允许的消息最大字符长度
          maxLength: 512,
          init: {
            // 设置我的基础信息
            mine: getCache().mine,
            // 好友列表数据
            friend: []
          },
          // 上传图片接口
          uploadImage: {
            // 接口地址
            url: `${getCache().uploadImageUrl}?api={"sesskey":"${getQueryObject().sesskey}","supportImg":1}`
          },
          // 上传文件接口
          uploadFile: {
            // 接口地址
            url: `${getCache().uploadImageUrl}?api={"sesskey":"${getQueryObject().sesskey}","supportImg":1}`,
            size: 1024 * 20
          }
        })
      }

      // 创建一个客服会话
      function createChat() {
        layim.chat({
          type: 'friend',
          ...getCache().customerService
        })
      }

      const readMessage = (() => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(({ target, intersectionRatio }) => {
            const { id } = target
            // 是否显示三分之一
            if (intersectionRatio >= 0.3) {
              // 没有发送已读
              if (target.dataset.read === '0') {
                // 图片消息显示三分之一, 文字消息全部显示
                if (target.querySelector('.layim-chat-img') || intersectionRatio === 1) {
                  send(sendRead(id))
                  target.dataset.read = '1'
                  observer.unobserve(target)
                }
              } else {
                observer.unobserve(target)
              }
            }
          })
        }, { threshold: [0.3, 1] }) // dom 显示三分之一到全部显示
        const observe = (id) => {
          const target = document.getElementById(id)
          if (target) {
            const { mine, read } = target.dataset
            // 不是我的消息, 未读
            if (mine === '0' && read === '0') {
              // 观察 dom 是否可见
              observer.observe(target)
            }
          }
        }
        const unobserve = (id) => {
          const target = document.getElementById(id)
          if (target) {
            observer.unobserve(target)
          }
        }
        return {
          observe,
          unobserve
        }
      })()

      function resetScroll() {
        const thatChat = layim.thisChat()
        const chatMain = thatChat.elem.find('.layim-chat-main')
        if (chatMain) {
          chatMain.scrollTop(chatMain[0].scrollHeight + 1000)
        }
      }
    })
  }
}
